import React from 'react'
import { Box, Table, TableBody, TableHead, TableRow } from '@material-ui/core'
import MuiTableCell from '@material-ui/core/TableCell'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { useAppState } from 'state'
import { weiToNum } from 'toolbelt'
import AaveIcon from 'components/Icons/Aave'

const useStyles = makeStyles({
  table: {
    border: '1px solid #A5A5A5',
    borderRadius: '4px',
  },
  separator: {
    border: '1px solid #A5A5A5',
    transform: 'rotate(180deg)',
  },
})

const TableCell = withStyles({
  root: {
    borderBottom: 'none',
  },
})(MuiTableCell)

const THCell = withStyles({
  root: {
    fontSize: '16px',
    borderBottom: '1px solid #A5A5A5',
  },
})(MuiTableCell)

interface AccountAssetsProps {
  aavePrice: number
}

const AccountAssets = ({ aavePrice }: AccountAssetsProps) => {
  const styles = useStyles()
  const { aaveBalance, underlyingBalance } = useAppState()
  const balance = weiToNum(aaveBalance)
  return (
    <Box>
      <Table className={styles.table}>
        <TableHead>
          <TableRow>
            <THCell></THCell>
            <THCell align="left">Assets</THCell>
            <THCell align="left">Balance</THCell>
            <THCell align="left">Price</THCell>
            <THCell align="left">Value</THCell>
            <THCell align="left">Total Staked in Pool</THCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell align="center">
              <AaveIcon />
            </TableCell>
            <TableCell align="left">Aave</TableCell>
            <TableCell align="left">{balance}</TableCell>
            <TableCell align="left">${aavePrice}</TableCell>
            <TableCell align="left">${aavePrice * parseFloat(balance)}</TableCell>
            <TableCell>{weiToNum(underlyingBalance)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  )
}

export default AccountAssets
